import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../../Request";
import {endLoading, startLoading} from "../../../../store/slices/loadingSlice";
import requestMiddlewares from "../../../requestMiddlewares";
import {GetSelectedCompany} from "../../../../utils/selectCompany";

export default async function (
  dispatch: Dispatch,
  id: string,
  companyId?: string,
  emailBase64?: string
): Promise<IResponse> {
  dispatch(startLoading());

  const cid = companyId ? companyId : GetSelectedCompany();
  if (!cid) {
    return {
      statusCode: 500,
      data: {
        message: 'No company selected'
      }
    }
  }

  const route = emailBase64 ? 'view' : 'viewPrivate'
  const request = new RACARequest('companyPackages', route)
    .setPathValues('COMPANY_ID', cid)
    .setPathValues('ID', id)

  if (emailBase64) {
    request.setQueryParameters({ email: emailBase64 })
  }

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );

  dispatch(endLoading());

  return response;
}
